export default "__VITE_ASSET__1dfa79a4__"